import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { useI18n } from "@/lib/i18n";

// AI-generated personalized insight, cached in localStorage per cacheKey to keep cost minimal.
export default function AiInsight({ cacheKey, prompt, title }) {
  const { profile } = useProfile();
  const { lang } = useI18n();
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!prompt) return;
    const key = `velyrea_ai_${cacheKey}_${lang}`;
    const cached = localStorage.getItem(key);
    if (cached) { setText(cached); setLoading(false); return; }
    let alive = true;
    setLoading(true); setError(false);
    api.post("/ai/consult", { message: prompt, profile })
      .then(({ data }) => { if (!alive) return; setText(data.reply); localStorage.setItem(key, data.reply); })
      .catch(() => alive && setError(true))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [cacheKey, prompt, lang, profile]);

  if (error) return null;

  return (
    <div className="rounded-2xl border border-olive/25 bg-gradient-to-br from-white to-olive/5 p-6" data-testid="ai-insight">
      <div className="flex items-center gap-2 text-olive-dark mb-3">
        <span className="w-8 h-8 rounded-full rose-gold-bg text-white flex items-center justify-center"><Sparkles size={16} /></span>
        <span className="text-xs uppercase tracking-widest font-semibold">{title || (lang === "it" ? "Analisi del Consulente AI" : "AI Consultant analysis")}</span>
      </div>
      {loading ? (
        <div className="space-y-2">
          <div className="h-3 bg-olive/10 rounded animate-pulse w-full" />
          <div className="h-3 bg-olive/10 rounded animate-pulse w-11/12" />
          <div className="h-3 bg-olive/10 rounded animate-pulse w-4/5" />
        </div>
      ) : (
        <p className="text-charcoal/80 leading-relaxed whitespace-pre-wrap">{text}</p>
      )}
    </div>
  );
}
